// import NPSChartConfig from '@/constants/NPS.js'
// import { MODULE_WIDGET_MAPS } from '@/constants/module'
import { Message } from 'element-ui'
import moment from 'dayjs'
import CommentListService from '@/hotelcem/apis/comment/commentListService'

const defaultState = {
  npsSearch: {
    score: {
      min: undefined,
      max: undefined,
    },
    stage: undefined,
    commentSpecial: undefined,
  },
  commentRawData: {
    loading: false,
  },
  npsChartRawData: {
    loading: false,
  },
  dataSourceRaw: {
    customDataSourceId_nps:
      process.env.VUE_APP_ENV === 'prod' ? '0a1711b88d1a46aba478d64b628c3761' : '2e28dc4489414c0ab89aea9a182f92c2',
    customDataSourceId_npsTrend:
      process.env.VUE_APP_ENV === 'prod' ? 'd416e27bb9c44b519d4e1e93313578e8' : 'd83fd638f6dc49329d7beec936861c05',
    //数据源ID --- 手动配置
    dataCustomModelId:
      process.env.VUE_APP_ENV === 'prod' ? '9d231f023d0844d5b6262857d89b9307' : 'b4b26a6afc6c4ec9916ebfac3020a64f',

    // 得分/评价特征
    scoreCol: {
      optionUid: 'score',
    },
    // 评价阶段
    stage: {
      optionUid: 'nps_stage',
    },
    // 酒店
    hotelCol: {
      optionUid: 'reserve_col_1',
    },
    // 时间
    timeCol: {
      optionUid: 'local_createtime',
    },
    // 文本字段
    textCol: {
      optionUid: 'commentcontent',
    },
  },
}
/**
 * 拼接所有筛选参数：全局+局部
 */
const getFilterList = (form, dateFilter, state) => {
  // 全局筛选器：酒店+时间
  let globalFilter = [
    {
      type: 'group',
      leftLogical: 'and',
      internalLogical: 'and',
      conditions: [],
    },
  ]
  // 时间
  globalFilter[0].conditions.push({
    type: 'group',
    internalLogical: 'and',
    conditions: [
      {
        type: 'value',
        columnId: state.dataSourceRaw.timeCol.columnId, // 时间字段
        columnType: 3,
        operate: 'gte',
        value: moment(dateFilter.dateRange[0]).toISOString(),
      },
      {
        type: 'value',
        columnId: state.dataSourceRaw.timeCol.columnId, //时间字段
        columnType: 3,
        operate: 'lte',
        value: moment(dateFilter.dateRange[1]).toISOString(),
      },
    ],
  })

  let filterList = globalFilter

  // 局部筛选器
  let interiorFilter = [
    {
      type: 'group',
      leftLogical: 'and',
      internalLogical: 'and',
      conditions: [],
    },
  ]

  // 分数区间
  if ((form.score.min || form.score.min == 0) && (form.score.max || form.score.max == 0)) {
    interiorFilter[0].conditions.push({
      type: 'group',
      internalLogical: 'and',
      conditions: [
        {
          type: 'value',
          columnId: state.dataSourceRaw.scoreCol.columnId, // 分数区间字段
          columnType: 2,
          operate: 'gte',
          value: form.score.min,
        },
        {
          type: 'value',
          columnId: state.dataSourceRaw.scoreCol.columnId, // 分数区间字段
          columnType: 2,
          operate: 'lte',
          value: form.score.max,
        },
      ],
    })
  } else if (form.score.min || form.score.min == 0 || form.score.max || form.score.max == 0) {
    const score = form.score.min == 0 || form.score.max == 0 ? 0 : form.score.min || form.score.max
    interiorFilter[0].conditions.push({
      type: 'group',
      internalLogical: 'and',
      conditions: [
        {
          type: 'value',
          columnId: state.dataSourceRaw.scoreCol.columnId, // 分数区间字段
          columnType: 2,
          operate: 'eq',
          value: score,
        },
      ],
    })
  }
  // 评价阶段
  if (form.stage) {
    interiorFilter[0].conditions.push({
      type: 'group',
      internalLogical: 'and',
      conditions: [
        {
          type: 'value',
          columnId: state.dataSourceRaw.stage.columnId, // 评价阶段字段
          columnType: 1,
          operate: 'eq',
          value: form.stage,
        },
      ],
    })
  }
  // 酒店
  interiorFilter[0].conditions.push({
    type: 'group',
    internalLogical: 'and',
    conditions: [
      {
        type: 'value',
        columnId: state.dataSourceRaw.hotelCol.columnId, // 酒店字段
        columnType: 1,
        operate: 'eq',
        value: dateFilter.hotelInfo.hotelInfo.realCtripHotelId || dateFilter.hotelInfo.hotelInfo.ctripHotelId,
      },
    ],
  })

  if (interiorFilter[0].conditions.length > 0) {
    filterList.push(...interiorFilter)
  }

  return filterList
}

export default {
  namespaced: true,
  state: VocDeepClone.deepClone(defaultState),
  mutations: {
    SET_RESET_SEARCH(state) {
      state.npsSearch = {
        score: {
          min: undefined,
          max: undefined,
        },
        stage: undefined,
        commentSpecial: undefined,
      }
    },
    SET_NPS_SEARCH(state, payload) {
      state.npsSearch = { ...state.npsSearch, ...payload }
    },
    SET_COMMENT_RAW_DATA(state, payload) {
      state.commentRawData = { ...state.commentRawData, ...payload }
    },
    SET_NPS_CHART_RAW_DATA(state, payload) {
      state.npsChartRawData = { ...state.npsChartRawData, ...payload }
    },
  },
  actions: {
    // 根据数据源查询字段数据
    async fetchColumnByDataSourceId({ rootState, state, commit, dispatch }, payload = {}) {
      const fieldDetailRes = await CommentListService.fetchNewSourceList({
        dataSourceGroupId: state.dataSourceRaw.dataCustomModelId,
      })
      const list = fieldDetailRes?.data?.columns || []
      for (const key in state.dataSourceRaw) {
        const optionUid = state.dataSourceRaw[key]?.optionUid
        if (optionUid) {
          const map = list.find(item => item.optionUid === optionUid)
          if (map) state.dataSourceRaw[key] = { ...map, columnId: map.uid }
        }
      }
    },
    // 点评列表查询
    async listCommentRawDataForCompetitor({ rootState, state, commit, dispatch }, payload = {}) {
      try {
        if (!state.dataSourceRaw.textCol?.columnId) return

        commit('SET_COMMENT_RAW_DATA', { loading: true })
        // 根据额外字段返回数值
        let extraColumnIdList = []
        for (const key in state.dataSourceRaw) {
          const columnId = state.dataSourceRaw[key]?.columnId
          if (columnId) {
            extraColumnIdList.push(columnId)
          }
        }

        const form = state.npsSearch
        let params = {
          columnIdList: [state.dataSourceRaw.textCol.columnId], // 文本分析字段---评论内容/投诉详情
          dataSourceId: state.dataSourceRaw.dataCustomModelId, // 数据源字段
          filterList: getFilterList(form, rootState.common.dateFilter, state), // 所有筛选字段
          page: {
            pageNo: payload.current,
            pageSize: payload.pageSize,
          },
          // 评价明细字段---传任何值都可以返回
          extraColumnIdList: extraColumnIdList,
          // 排序字段根据时间字段来
          columnSorting: [
            {
              columnId: state.dataSourceRaw.timeCol.columnId,
              isDescend: true,
            },
          ],
          noTenantQuery: true,
        }
        const res = await CommentListService.fetchOriginDataList(params)
        if (res?.data && res?.code === 200) {
          let list =
            res.data.records?.length > 0
              ? res.data.records.map(item => {
                  const { extraValues } = item
                  return {
                    ...item,
                    fieldObject: {
                      score: extraValues[state.dataSourceRaw.scoreCol.columnId],
                      time: extraValues[state.dataSourceRaw.timeCol.columnId],
                      stage: extraValues[state.dataSourceRaw.stage.columnId],
                    },
                  }
                })
              : []
          let rowDataMap = {
            rawTotal: res.data.total,
            rowData: list,
          }

          if (payload.append) {
            rowDataMap.rowData = state.commentRawData?.rowData?.concat(list)
            commit('SET_COMMENT_RAW_DATA', rowDataMap)
          } else {
            commit('SET_COMMENT_RAW_DATA', rowDataMap)
          }
        }

        if (res?.code === 400) {
          commit('SET_COMMENT_RAW_DATA', {
            rowData: [],
            rawTotal: 0,
          })
          Message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
      commit('SET_COMMENT_RAW_DATA', { loading: false })
    },
    // 获取nps图表信息
    // async listNPSChartForAnalysis({ rootState, state, commit, dispatch }, payload = {}) {
    //   try {
    //     commit('SET_NPS_CHART_RAW_DATA', { loading: true })
    //     const charts = [
    //       {
    //         canDel: false,
    //         uid: 'nps',
    //         customModelUid: '69d37c75294d4a6fb58fa0c91502ddaf',
    //         modelInfo: NPSChartConfig().npsConfig.nps,
    //         type: 1,
    //         name: 'NPS',
    //         customAttr: {}, // parseJson(item.itemInfo), // 图表位置，不设置
    //         widget: MODULE_WIDGET_MAPS['MODULE_1'],
    //       },
    //       {
    //         canDel: false,
    //         uid: 'npsTrend',
    //         customModelUid: '69d37c75294d4a6fb58fa0c91502ddaf',
    //         modelInfo: NPSChartConfig().npsConfig.npsTrend,
    //         type: 1,
    //         name: 'NPS趋势',
    //         customAttr: {}, // parseJson(item.itemInfo), // 图表位置，不设置
    //         widget: MODULE_WIDGET_MAPS['MODULE_1'],
    //       },
    //     ]

    //     let rowDataMap = {
    //       nps: charts[0],
    //       npsTrend: charts[1],
    //     }

    //     commit('SET_NPS_CHART_RAW_DATA', rowDataMap)
    //   } catch (error) {
    //     console.error(error)
    //   }

    //   commit('SET_NPS_CHART_RAW_DATA', { loading: false })
    // },
  },
}
